/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_Primary_LabelInputs */

const en_admin_design_settings_primary_label = /** @type {(inputs: Admin_Design_Settings_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary color`)
};

const de_admin_design_settings_primary_label = /** @type {(inputs: Admin_Design_Settings_Primary_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primärfarbe`)
};

/**
* | output |
* | --- |
* | "Primary color" |
*
* @param {Admin_Design_Settings_Primary_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_primary_label = /** @type {((inputs?: Admin_Design_Settings_Primary_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_Primary_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_primary_label(inputs)
	return en_admin_design_settings_primary_label(inputs)
});